import * as XLSX from "xlsx";

export const exportRegisteredAttendee = (data) => {
  if (!data || data.length === 0) return;

  // Extract all unique custom field labels, normalizing them
  // so we don't get duplicate columns like "Gender" / "gender".
  const customFieldMap = new Map(); // normalizedKey -> displayLabel

  // Core fields that are already exported as FirstName, LastName, Email, PhoneNumber
  // and therefore should NOT appear again as custom columns, even if present in customFields.
  const coreFieldNames = [
    "firstname",
    "first name",
    "first_name",
    "lastname",
    "last name",
    "last_name",
    "email",
    "e-mail",
    "email address",
    "phone",
    "phone number",
    "phonenumber",
    "phone_num",
    "phoneNum".toLowerCase(), // just in case label is "phoneNum"
  ];

  data.forEach((attendee) => {
    if (attendee.customFields && Array.isArray(attendee.customFields)) {
      attendee.customFields.forEach(({ label }) => {
        const raw = label && label.toString().trim();
        const normalized = raw && raw.toLowerCase();
        if (
          normalized &&
          !coreFieldNames.includes(normalized) &&
          !customFieldMap.has(normalized)
        ) {
          customFieldMap.set(normalized, raw);
        }
      });
    }
  });

  const allCustomLabels = Array.from(customFieldMap.values());

  // Map attendees to include custom fields dynamically
  const formattedData = data.map(
    ({ firstName, lastName, email, phoneNumber, customFields }) => {
      const customFieldValues =
        customFields?.reduce((acc, { label, value }) => {
          const raw = label && label.toString().trim();
          const normalized = raw && raw.toLowerCase();
          const displayLabel =
            (normalized && customFieldMap.get(normalized)) || raw;
          if (displayLabel) {
            acc[displayLabel] = value;
          }
          return acc;
        }, {}) || {};

      return {
        FirstName: firstName,
        LastName: lastName,
        Email: email,
        PhoneNumber: phoneNumber,
        ...allCustomLabels.reduce((acc, label) => {
          acc[label] = customFieldValues[label] || ""; // Ensure all columns exist
          return acc;
        }, {}),
      };
    }
  );

  // Create workbook and worksheet
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(formattedData);

  // Append worksheet to workbook and save file
  XLSX.utils.book_append_sheet(workbook, worksheet, "RegisteredAttendees");
  XLSX.writeFile(workbook, "RegisteredAttendees.xlsx");
};

// export const exportRegisteredAttendee = (data) => {
//   const workbook = XLSX.utils.book_new();
//   const worksheet = XLSX.utils.json_to_sheet(
//     data?.map(({ firstName, lastName, email, phoneNumber }) => ({
//       FirstName: firstName,
//       LastName: lastName,
//       Email: email,
//       PhoneNumber: phoneNumber,
//     }))
//   );

//   XLSX.utils.book_append_sheet(workbook, worksheet, "RegisterAttendee");
//   XLSX.writeFile(workbook, "RegisterAttendee.xlsx");
// };
